import React from 'react';
import LabelPrintTracking from '../LabelPrintTracking';

/**
 * Class Printing displays the printing status
 */
export default class CheckAgain extends React.Component {
  handleOnClick() {
    LabelPrintTracking.track(LabelPrintTracking.events.VISITED_SSL);
  }

  render() {
    return (
      <div className="cr-maple-200">
        <p className="cr-text-s cr-mv-0">
          Unable to detect the Zebra Browser Print application. Verify the following:
        </p>
        <ul className="cr-text-s cr-mb-0">
          <li>The Zebra Browser Print application is running on your computer</li>
          <li>
            The SSL certificate is trusted on{' '}
            <a
              className="notranslate"
              href="https://localhost:9101/available"
              onClick={this.handleOnClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://localhost:9101/available
            </a>
          </li>
          <li>The domain is added inside the Accepted Hosts of Zebra Browser Print</li>
        </ul>
      </div>
    );
  }
}
